import { gql } from '@apollo/client';

// Gestión de grupos de las banderitas: SOLO con red. No pasan por la cola
// offline (`ONLINE_ONLY_OPERATIONS` de `OfflineQueueLink`, spec § 9.5); si se
// renombra una operación hay que cambiarla también allí.

export const CREATE_USER_GROUP = gql`
  mutation CreateUserGroup($name: String!) {
    createUserGroup(name: $name) {
      id
      name
      createdAt
      updatedAt
      members {
        id
        name
        surName
        email
        rolActive
        isActive
      }
    }
  }
`;

export const RENAME_USER_GROUP = gql`
  mutation RenameUserGroup($id: ID!, $name: String!) {
    renameUserGroup(id: $id, name: $name) {
      id
      name
      createdAt
      updatedAt
      members {
        id
        name
        surName
        email
        rolActive
        isActive
      }
    }
  }
`;

export const DELETE_USER_GROUP = gql`
  mutation DeleteUserGroup($id: ID!) {
    deleteUserGroup(id: $id)
  }
`;

export const ADD_USER_GROUP_MEMBERS = gql`
  mutation AddUserGroupMembers($id: ID!, $userIds: [ID!]!) {
    addUserGroupMembers(id: $id, userIds: $userIds) {
      id
      name
      createdAt
      updatedAt
      members {
        id
        name
        surName
        email
        rolActive
        isActive
      }
    }
  }
`;

export const REMOVE_USER_GROUP_MEMBERS = gql`
  mutation RemoveUserGroupMembers($id: ID!, $userIds: [ID!]!) {
    removeUserGroupMembers(id: $id, userIds: $userIds) {
      id
      name
      createdAt
      updatedAt
      members {
        id
        name
        surName
        email
        rolActive
        isActive
      }
    }
  }
`;
